import AbstractGenLex, { GenLexWithLibelle, GenLexWithLabel } from './abstract-gen-lex';
import { Model } from './abstract-model';

@Model('LcavDangerosite') export class LcavDangerosite extends GenLexWithLibelle {}
@Model('LcavNatureType') export class LcavNatureType extends AbstractGenLex {
  public nature: string;
  public typeCavite: string;
  public libelleType: string;
  public numero: string;
}
@Model('LcavSourceCoordonnees') export class LcavSourceCoordonnees extends AbstractGenLex {
  public sourceCoordonnees: string;
}
@Model('LcavStatut') export class LcavStatut extends AbstractGenLex {
  public lcavTypecav: string;
  public statut: string;
}
@Model('LcavTypePositionnement') export class LcavTypePositionnement extends AbstractGenLex {
  public typePositionnement: string;
  public libellePosition: string;
}
@Model('LcavTypeReperage') export class LcavTypeReperage extends AbstractGenLex {
  public lcavNatureType: string;
  public typeReperage: string;
  public libelleReperage: string;
}
@Model('LcavTypecav') export class LcavTypecav extends AbstractGenLex {
  public famille: string;
  public genre: string;
}

/* -- */

@Model('LexCusActionAdministrative') export class LexCusActionAdministrative extends GenLexWithLibelle {}
@Model('LexCusActionReglementaire') export class LexCusActionReglementaire extends GenLexWithLibelle {}
@Model('LexCusConnaissanceCavite') export class LexCusConnaissanceCavite extends GenLexWithLibelle {}
@Model('LexCusEtatGeneral') export class LexCusEtatGeneral extends GenLexWithLibelle {}
@Model('LexCusEtatRadier') export class LexCusEtatRadier extends GenLexWithLibelle {}
@Model('LexCusIntervenant') export class LexCusIntervenant extends GenLexWithLibelle {}
@Model('LexCusMiseSecurite') export class LexCusMiseSecurite extends GenLexWithLibelle {}
@Model('LexCusNiveauAlea') export class LexCusNiveauAlea extends GenLexWithLibelle {}
@Model('LexCusPositionnement') export class LexCusPositionnement extends GenLexWithLibelle {}
@Model('LexCusProprietaire') export class LexCusProprietaire extends GenLexWithLibelle {}
@Model('LexCusTypeAcces') export class LexCusTypeAcces extends GenLexWithLibelle {}
@Model('LexCusTypeAction') export class LexCusTypeAction extends GenLexWithLibelle {}
@Model('LexCusTypeDesordre') export class LexCusTypeDesordre extends GenLexWithLibelle {}
@Model('LexCusTypeOuvrage') export class LexCusTypeOuvrage extends GenLexWithLibelle {}
@Model('LexCusTypePlan') export class LexCusTypePlan extends GenLexWithLibelle {}
@Model('LexCusTypeTravaux') export class LexCusTypeTravaux extends GenLexWithLibelle {}

/* -- */

@Model('LexPocAcces') export class LexPocAcces extends GenLexWithLabel {}
@Model('LexPocEnjeuxSurface') export class LexPocEnjeuxSurface extends GenLexWithLabel {}
@Model('LexPocEtatAcces') export class LexPocEtatAcces extends GenLexWithLabel {}
@Model('LexPocEvenementObservation') export class LexPocEvenementObservation extends GenLexWithLabel {}
@Model('LexPocModaliteAcces') export class LexPocModaliteAcces extends GenLexWithLabel {}
@Model('LexPocPreconisation') export class LexPocPreconisation extends GenLexWithLabel {
  public jours: number; //int
}
@Model('LexPocSuivi') export class LexPocSuivi extends GenLexWithLabel {}

/* -- */

@Model('LsitCarteIgn25') export class LsitCarteIgn25 extends AbstractGenLex {
  public numCarte: string;
}
@Model('LsitCavConfidentialite') export class LsitCavConfidentialite extends AbstractGenLex {
  public confidentialite: string;
}
@Model('LsitCavKeycode') export class LsitCavKeycode extends AbstractGenLex {
  public id: number; //int
  public cptCavites: number; //int
}

/* -- */

@Model('LexEtatCaviteEaux') export class LexEtatCaviteEaux extends GenLexWithLibelle {}
@Model('LexNatureMateriau') export class LexNatureMateriau extends GenLexWithLibelle {}

@Model('LexCodeFiabilite') export class LexCodeFiabilite extends GenLexWithLabel {}